// Module
var code = "<div ui-view id=\"mx-app\"></div>";
// Exports
export default code;